import { SvgIconProps, Theme } from '@mui/material';
import {
  CreateTransactionIcon,
  DonutIcon,
  FloppyDishClockIcon,
  LogoIcon,
  WalletIcon,
  WandStartIcon
} from "../components/ui/icons";
import { ROUTES } from './routes';

export interface BaseMenuItem {
  key: string;
  path: string;
  translationKey: string;
  badge?: string;
  onClick?: () => void;
  href?: string;
  hidden?: boolean;
  textStyle?: React.CSSProperties;
}

export interface BasicNavItem extends BaseMenuItem {
  type: 'basic';
}

export type MenuItem = BasicNavItem;

export const basicNavItems: BasicNavItem[] = [
  {
    key: 'overview',
    type: 'basic',
    path: ROUTES.OVERVIEW,
    translationKey: 'bottomNav.overview',
  },
  {
    key: 'assets',
    type: 'basic',
    path: ROUTES.ASSETS,
    translationKey: 'bottomNav.assets',
  },
  {
    key: 'addTransaction',
    type: 'basic',
    path: ROUTES.CREATE_BASIC_TRANSACTION,
    translationKey: 'bottomNav.addTransaction',
    textStyle: { marginTop: 2.5 },
  },
  {
    key: 'history',
    type: 'basic',
    path: ROUTES.HISTORY,
    translationKey: 'bottomNav.history',
  },
  {
    key: 'discover',
    type: 'basic',
    path: ROUTES.DISCOVER,
    translationKey: 'bottomNav.discover',
  },
];

export const allMenuItems: MenuItem[] = [...basicNavItems];


// Icon configuration function that returns component and props
export const getMenuItemIconConfig = (itemKey: string, theme: Theme) => {
  const iconConfigs: Record<string, { component: React.ComponentType<SvgIconProps>; props: SvgIconProps }> = {
    overview: { component: LogoIcon, props: { style: { fontSize: 24 } } },
    assets: { component: WalletIcon, props: { style: { fontSize: 24 } } },
    budget: { component: DonutIcon, props: { style: { fontSize: 24 } } },
    history: { component: FloppyDishClockIcon, props: { style: { fontSize: 24 } } },
    discover: { component: WandStartIcon, props: { style: { fontSize: 24 } } },
    addTransaction: {
      component: CreateTransactionIcon,
      props: {
        style: {
          fontSize: 49,
          position: 'absolute',
          transform: 'translateY(-50%)',
          boxShadow: theme.shadows[2],
          color: theme.palette.text.primary,
          borderRadius: '50%',
        }
      }
    },
  };

  return iconConfigs[itemKey];
}; 